import axios from '~/utils/request'

export function createMenu(data) {
  return axios({
    method: 'post',
    url: '/api/MenuManager/CreateMenu',
    data
  })
}

export function updateMenu(data) {
  return axios({
    method: 'put',
    url: '/api/MenuManager/EditMenu',
    data
  })
}

export function deleteMenu(params) {
  return axios({
    method: 'delete',
    url: '/api/MenuManager/DeleteMenuInfo?menuId=' + params.id
  })
}

export function getAllMenuList(params) {
  return axios({
    method: 'get',
    url: '/api/MenuManager/GetAllMenuList',
    params: params
  })
}

export function getMenuInfoPage(params) {
  return axios({
    method: 'get',
    url: '/api/MenuManager/GetMenuInfoPage',
    params: params
  })
}

export function getMenuList(params) {
  return axios({
    method: 'get',
    url: '/api/MenuManager/GetMenuList',
    params: params
  })
}

export function getMenuListByRoleId(params) {
  return axios({
    method: 'get',
    url: '/api/MenuManager/GetMenuListByRoleId',
    params: params
  })
}
